import {
  EMPTY_STRING,
  RETURN_URL_QUERY_PARAM,
} from '@assetron/common/constants/constant';
import useConfig from '@assetron/common/hooks/useConfig';
import useExternalRedirect from '@assetron/web-common/hooks/useExternalRedirect';
import Cookie from 'js-cookie';
import { IS_USER_LOGGED_IN } from '@assetron/web-common/constants/LocalStorageConstants';

interface PublicRoutesProps {
  children: JSX.Element;
  isAuthenticated: boolean;
}

function PublicRoutes({ children, isAuthenticated }: PublicRoutesProps) {
  const { APP_URL } = useConfig();
  const hasCookieBackedLogin = Cookie.get(IS_USER_LOGGED_IN) === 'true';
  const shouldStayOnAuthRoute = !isAuthenticated || !hasCookieBackedLogin;

  // Get return URL from current query parameters instead of localStorage
  const urlParams = new URLSearchParams(globalThis.location.search);
  const returnUrlFromParams = urlParams.get(RETURN_URL_QUERY_PARAM);
  const returnUrl = returnUrlFromParams ?? APP_URL;

  // Do not redirect to the web app on Firebase auth state alone. The auth app
  // must wait until /api/v1/auth/tokens has completed and written the
  // cookie-backed login marker, otherwise the web app races into protected
  // routes before the backend session exists.
  useExternalRedirect(shouldStayOnAuthRoute, returnUrl, EMPTY_STRING);
  return children;
}

export default PublicRoutes;
